export interface ExternalLink {
  pattern: RegExp;
  url: string;
  label: string;
}

export const externalLinks: ExternalLink[] = [
  // Operators & Activities
  { pattern: /Ice Activity Park(?: Levi)?/gi, url: 'https://icekarting.fi/', label: 'Ice Activity Park Levi' },
  { pattern: /G2 Ice Karting/gi, url: 'https://www.tripadvisor.com/Attraction_Review-g677549-d12937598-Reviews-G2_Ice_Karting_Levi-Sirkka_Levi_Lapland.html', label: 'G2 Ice Karting' },
  { pattern: /Scandinavian Travel Group/gi, url: 'https://www.scandinavian-travel-group.com/', label: 'Scandinavian Travel Group' },
  { pattern: /Levi Ski School|ski school(?= in| at| for)/gi, url: 'https://www.levi.fi/en/ski/ski-school/', label: 'Levi Ski School' },
  { pattern: /Ylläs Ski Resort/gi, url: 'https://ski.yllas.fi/', label: 'Ylläs Ski Resort' },
  { pattern: /Levi Ski Resort/gi, url: 'https://www.levi.fi/en/info/levi-ski-resort/', label: 'Levi Ski Resort' },
  { pattern: /Ylläs Bike Park/gi, url: 'https://ski.yllas.fi/en/bike-park/', label: 'Ylläs Bike Park' },
  { pattern: /Samiland(?:\s+Exhibition)?/gi, url: 'https://www.levi.fi/en/services/samiland/', label: 'Samiland Exhibition' },
  { pattern: /Siida(?:\s+Museum)?/gi, url: 'https://siida.fi/en/', label: 'Siida Museum' },
  { pattern: /Foxfires(?:\s+Arctic\s+Spa)?/gi, url: 'https://www.levi.fi/en/services/foxfires-arctic-spa-sauna-experience/', label: 'Foxfires Arctic Spa' },

  // Resorts & Tourism
  { pattern: /Visit Levi/gi, url: 'https://www.levi.fi/en/', label: 'Visit Levi' },
  { pattern: /Visit Ylläs/gi, url: 'https://yllas.fi/en/', label: 'Visit Ylläs' },
  { pattern: /Pallas-Yll[äa]stunturi National Park/gi, url: 'https://www.luontoon.fi/en/pallas-yllastunturi', label: 'Pallas-Yllästunturi National Park' },
  { pattern: /Kittil[äa] Airport(?:\s*\(KTT\))?/gi, url: 'https://www.finavia.fi/en/airports/kittila', label: 'Kittilä Airport' },
  { pattern: /Kellokas/gi, url: 'https://yllas.fi/en/area-info/pallas-yllastunturi-national-park.html', label: 'Fell Lapland Visitor Centre Kellokas' },

  // Restaurants
  { pattern: /(?:Wanha\s+)?Hullu\s+Poro/gi, url: 'https://hulluporo.fi/en/', label: 'Wanha Hullu Poro' },
  { pattern: /Levin\s+Panimo/gi, url: 'https://www.levinpanimo.fi/', label: 'Levin Panimo & Pub' },
  { pattern: /Nili[-\s]Poro/gi, url: 'https://www.levi.fi/en/services/nili/', label: 'Nili-Poro' },
  { pattern: /Pihvikeisari/gi, url: 'https://www.pihvikeisari.com/', label: 'Pihvikeisari' },
  { pattern: /Aurora Estate/gi, url: 'https://www.auroraestate.fi/', label: 'Aurora Estate' },
  { pattern: /Yll[äa]s Humina/gi, url: 'https://www.yllashumina.com/', label: 'Ylläs Humina' },
  { pattern: /Y1\s+(?:Food Garden|Restaurants?|Ski Pub)/gi, url: 'https://www.laplandhotels.com/en/ski-resorts/yllas-ski-resort/y1-restaurants', label: 'Y1 Restaurants' },
  { pattern: /Jounin\s+Kauppa/gi, url: 'https://jouninkauppa.com/en/', label: 'Jounin Kauppa' },
  { pattern: /Eelin\s+Kauppa/gi, url: 'https://eelinkauppa.fi/en/', label: 'Eelin Kauppa' },

  // Events
  { pattern: /Yll[äa]s[-\s]Levi Hiihto/gi, url: 'https://yllaslevi.fi/en/', label: 'Ylläs-Levi Hiihto' },
  { pattern: /Yll[äa]s[-\s]Levi MTB/gi, url: 'https://yllaslevimtb.fi/en/', label: 'Ylläs-Levi MTB' },

  // Data Sources
  { pattern: /Finnish Meteorological Institute|(?<!\w)FMI(?!\w)/g, url: 'https://en.ilmatieteenlaitos.fi/', label: 'FMI' },
  { pattern: /Fintraffic(?:\s*\/?\s*Digitraffic)?/gi, url: 'https://liikennetilanne.fintraffic.fi/', label: 'Fintraffic' },

  // Sustainability
  { pattern: /Sustainable Travel Finland/gi, url: 'https://www.visitfinland.fi/en/liiketoiminnan-kehittaminen/vastuullinen-matkailu/sustainable-travel-finland', label: 'Sustainable Travel Finland' },
  { pattern: /Visit Finland/gi, url: 'https://www.visitfinland.com/en/practical-tips/sustainability/', label: 'Visit Finland' },
];
